import jack from 'jack-logs';
import Perf from 'react-addons-perf';

window.Perf = Perf;

let recorderRunning = false;

if (__DEV__) {
  document.addEventListener('keyup', (e) => {
    if (e.key !== 'r' && !e.ctrlKey) {
      return null;
    }
    if (recorderRunning) {
      recorderRunning = false;
      jack.dev.log('Stopping Performance Recording');
      return Perf.stop();
    }
    recorderRunning = true;
    jack.dev.log('Starting Performance Recording');
    return Perf.start();
  });
}



// WEBPACK FOOTER //
// ./src/lib/perfRecorder.js